import get from 'lodash/get';
import { getHints } from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

export const getCourseContainerModulePromos = createSelector(getHints, (hints) =>
    get(hints, 'course_container_module_promo')
);
